
















































































/* eslint-disable camelcase */

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import langChanger from '@/modules/FPKG-20000-Util/components/langChanger/index.vue';
import myFunction from './components/function/index.vue';
import message from './components/message/index.vue';
import Socket from '@/modules/FPKG-80000-Socket/hud/index';

// localStorage.setItem('LogoUrl', './style/logo.png'); // 設定預設logo

@Component({
  components: {
    message,
    myFunction,
  },
})
export default class Header extends mixins(Socket) {
  @Prop() idle_time!: string | null;
  @Prop() isShow_idle?: boolean;

  private sidebar: boolean = false;

  // sidebar的開關狀態
  private tagShow: boolean = true; // sidebar的開關狀態

  private PCsidebar: boolean = false; // PCsidebar的開關狀態

  private toolbar: boolean = false; // 工具列的開關狀態

  @Watch('$route')
  public turnOffSidebar() {
    this.$bus.$emit('sidebar', false);
    this.sidebar = false;
  }

  get getSidebarWidth() {
    return this.$store.state.getSidebar.width;
  }

  private gofistNode() {
    const node = JSON.parse(localStorage.getItem('Node') || '{}');
    // 尋找第一個節點
    const firstNode = node.filter((item: any) => item.p4_node_route);
    this.$router.push(`/${firstNode[0].p4_node_route}`);
  }

  public created() {
    const socket = Socket;

    // 接收bus 傳過來的值
    this.$bus.$on('sidebar', (params: boolean) => {
      this.sidebar = params;
    });
    this.$bus.$on('toolbar', (status: boolean) => {
      this.toolbar = status;
    });
  }
}
